const pathsToMatch = ['/location_external_data', 'locations'];

if (pathsToMatch.some(path => window.location.pathname.includes(path))) {
  document.addEventListener("DOMContentLoaded", () => {
    removeDayLabel();
    refreshAfterSync();
  });
}

const removeDayLabel = () => {
  const dayLabel = $("li.fragment > label[for='location_external_data_paid_until_3i']");
  if (dayLabel.length) {
    dayLabel.hide();
  }
};

const refreshAfterSync = () => {
  const syncLinks = document.querySelectorAll('.sync');
  const syncAllLink = document.getElementById('syncAll');

  if (syncLinks) {
    syncLinks.forEach(syncLink => {
      syncLink.addEventListener('click', () => {
        setTimeout(() => window.location.reload(true), 3000);
      });
    });
  }

  if (syncAllLink) {
    syncAllLink.addEventListener('click', () => {
      setTimeout(() => window.location.reload(true), 10000);
    });
  }
};
